<template>
  <div
    class="flex column"
    v-if="
      ($store.state.app.pages[pagetitle || $route.params.pagetitle] &&
        ($store.state.app.pages[pagetitle || $route.params.pagetitle]
          .published ||
          $store.state.app.user.includes($store.state.auth.uid))) ||
      ($store.state.app.advanced.roles.admin &&
        $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.includes(
          $store.state.auth.uid
        ))
    "
  >
    <div class="flex wrap" :class="$store.state.windowWidth < 540 ? 'column' : ''">
      <!-- <div
        v-if="page.automenu && page.components.length > 1"
        class="flex column p4 flexz m8 container sticky"
      >
        <b class="border-bottom p8 flex align-center between">{{ pagetitle.toUpperCase() }}<i v-if="$store.state.windowWidth < 540" class="fa fa-bars" :class="show[pagetitle+'menu'] ? 'fa-rotate-90' : ''" @click="$set(show, pagetitle+'menu', !show[pagetitle+'menu'])"></i> </b>
        <div
          v-for="comp in page.components"
          :key="'automenu' + pagetitle + '-sub-' + comp.name"
        >
          <a
            v-if="show[pagetitle+'menu'] || $store.state.windowWidth >= 540"
            class="sm-font r8"
            :href="`#${'ipage_' + pagetitle.norm() + '_' + comp.name.norm()}`"
            ><i class="fa fa-link r4"></i>{{ comp.name.toUpperCase() }}</a
          >
        </div>
      </div> -->
      <div class="flexx" style="max-width: 100%; line-break: auto;">
        <keep-alive>
          <component
            class="flexw"
            :id="'ipage_' + pagetitle.norm()"
            :is="'ipage'"
            :pagetitle="pagetitle"
            :key="pagetitle"
          />
          <!-- Possible counter kill for some open materials -->
        </keep-alive>
    
        <div v-for="page in page.pages" :key="pagetitle + '-sub-' + page">
          <ipage
            :id="'ipage_' + pagetitle.norm() + '_' + page.norm()"
            :class="'ipage_' + pagetitle.norm() + '_' + page.norm()"
            :pagetitle="page"
          />
        </div>
      </div>
    </div>
  </div>

  <div v-else class="label warn p32 m16">
    <h5 class="flex align-center b8">
      <i class="fas fa-exclamation-triangle r4" />
      {{ pagetitle.toUpperCase() }} is unavialble.
    </h5>
    <code
      >If you think this is an error, check yourself before you wreck yourself,
      or somehow contact the app admin. Good luck!</code
    >
  </div>
</template>
<script>
export default {
  props: ["pagetitle"],
  data(){
    return {
      show:{}
    }
  },
  computed: {
    page() {
      return this.$store.state.app.pages[
        this.pagetitle || this.$route.params.pagetitle
      ];
    },
  },
};
</script>